import script from "./ProductTableRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductTableRow.vue?vue&type=script&lang=ts&setup=true"

import "./ProductTableRow.vue?vue&type=style&index=0&id=40a2f7e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40a2f7e2"]])

export default __exports__